/**
 * Validate fields for containing only letters, numbers, spaces, and dashes (and not empty)
 *
 * @param {string} input - the value of the field being validated
 * @return {boolean} isValid - does the input value pass the test
 */
function alphaNumericValidator(input) {
  const regexpTest = /^[\w\-\s]+$/;
  const isValid = regexpTest.test(input) && input.length > 0;

  return isValid;
}

export default alphaNumericValidator;



// WEBPACK FOOTER //
// ./scripts/util/validation/alphaNumericValidator.js